var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 386,
    viewBox: "-60 23 406 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Man / Head / 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M217.109 384.529L215.399 325.552C215.399 325.552 287.212 331.258 302.575 323.294C302.575 323.294 317.749 226.202 298.503 171.21L146.956 153.519L135.884 241.625C130.779 226.598 91.226 208.24 80.2118 229.758C56.3456 276.385 141.682 307.78 141.682 307.78L133.017 385.239",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M141.223 246.819C126.77 227.023 108.059 221.542 102.895 220.363C96.6005 192.181 89.2046 119.226 177.348 107.652C282.58 93.8363 298.503 171.21 298.503 171.21L162.948 169.552V241.4L141.223 246.819Z",
    fill: "#FCBDA4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    opacity: 0.402158,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.399 325.551L166.975 315.189L215.165 347.678L215.399 325.551Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.343 229.172L272.078 269.999L252.02 270.254L255.343 229.172Z",
    fill: "#405FD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.264 240.774C237.261 246.273 233.602 251.535 228.094 252.529C222.584 253.524 217.31 249.872 216.315 244.376C215.317 238.878 218.977 233.615 224.485 232.62C229.995 231.627 235.267 235.276 236.264 240.774Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.894 240.774C289.892 246.273 286.232 251.535 280.724 252.529C275.214 253.524 269.94 249.872 268.945 244.376C267.948 238.878 271.607 233.615 277.115 232.62C282.625 231.627 287.897 235.276 288.894 240.774Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.536 281.815C234.536 281.815 241.545 293.158 255.428 292.197L234.536 281.815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 14",
    d: "M234.536 281.815C234.536 281.815 241.545 293.158 255.428 292.197",
    stroke: "#252535",
    strokeWidth: 4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.202dd184.svg";
export { ForwardRef as ReactComponent };